import Vue from "vue";
import { MutationTree } from "vuex/types";

import { EcareState } from "./types";

const mutations: MutationTree<EcareState> = {
  ECARE_SET_DASHBOARDS: (state, payload) => {
    Vue.set(state, "dashboards", payload);
  },
  ECARE_SET_SELECTED_TAB: (state, payload) => {
    Vue.set(state, "selectedTab", payload);
  },
  ECARE_SET_EDITOR_VISIBLE: (state, payload) => {
    Vue.set(state, "editorVisible", payload);
  },
  ECARE_TOGGLE_EDITOR_VISIBLE: (state) =>{
    Vue.set(state, "editorVisible", !state.editorVisible);
  },
};

export default mutations;
